<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="operate">
      <div class="search">
        <date-picker
          v-model="search.join_date_S"
          :position="'right'"
          placeholder="入會日期開始"
        ></date-picker>

        <date-picker
          v-model="search.join_date_E"
          :position="'right'"
          placeholder="入會日期結束"
        ></date-picker>
      </div>
    </div>

    <b-button class="mr-2" variant="success" @click="exportJoinFee()">匯出入會費、報聘費</b-button>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import datePicker from '@/components/common/DatePicker';
import { downloadFile } from "@/models/HELPERS/common.js";

export default {
  name: 'exportReport',
  components: {
    BreadCrumb,
    datePicker
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '匯出報表', url: '', isActive: false }
        ]
      },
      search: {
        join_date_S: '',
        join_date_E: ''
      },
      status: {

      },
      data: {

      }
    }
  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {

    },
    // 匯出入會費、報聘費excel
    exportJoinFee() {
      this.reportApi.exportJoinFee((response) => {
        if (!response) return;

        downloadFile(response);
      }, this.search)
    }
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/exportReport.vue